import React from "react";

import classes from "./ClassCardV2.scss";
import classNames from "classnames";

import { Tooltip } from "@toddle-edu/ds-web";
import { TickCircleFilled } from "@toddle-edu/ds-icons";

const ClassCardV2 = React.memo(props => {
  const { course, onClassSelect, selected } = props;
  const { title, id, isArchived, curriculumProgram } = course;

  const classCardContainerClasses = classNames(classes.container, {
    [classes.cardSelected]: selected,
    archivedBg: isArchived,
  });

  return (
    <div
      data-test-id={`button-course-${course?.id}`}
      className={classCardContainerClasses}
      onClick={() => onClassSelect(id, curriculumProgram)}
    >
      <Tooltip placement={"top"} tooltip={title}>
        <div className={classNames("text-label-2", classes.classTitle)}>
          {title}
        </div>
      </Tooltip>

      <div className={classes.selectionContainer}>
        {selected ? (
          <TickCircleFilled variant={"success"} size={"x-small"} />
        ) : (
          <div className={classes.radioButton} />
        )}
      </div>
    </div>
  );
});

ClassCardV2.displayName = "ClassCardV2";
export default ClassCardV2;
